<div *ngIf="(loading$|async)" class="d-flex justify-content-center align-items-center h-100 w-100">
  <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
</div>

<ng-scrollbar visibility="hover" class="w-100 vh-100 position-relative d-flex flex-column"
                   *ngIf="!(loading$ |async) && (userPage$| async) as userPage"
                   [config]="{suppressScrollX: showEditField, suppressScrollY: showEditField}">


  <div class="member-page d-flex flex-column">
    <div class="title-picture-container position-relative">
      <img alt="background" class="title-picture" [src]="titlePicture ?? 'assets/img/profile/default-banner.jpg'"/>
      <ng-container *ngIf="activeUserId === pageUserId">
        <label for="title-picture-upload" class="edit-container edit-title-picture">
          <mat-icon>edit</mat-icon>
        </label>
        <input id="title-picture-upload" type="file" accept="image/png, image/jpeg"
               (change)="onFileChange($event, 'titlePicture')"
               class="d-none">
      </ng-container>
    </div>
    <div class="under-title-picture">
      <div class="profile-picture-container">
        <img alt="profile" class="profile-picture"
             [src]="profilePicture ?? 'assets/img/profile/default-profile-icon.png'"/>
        <ng-container *ngIf="activeUserId === pageUserId">


          <span (click)="editImage= true" class="edit-container edit-profile-picture">
            <img src="assets/svg-icons/camera.svg" alt="">
          </span>
        </ng-container>
      </div>

      <div class="information-card">
        <span class="name">
          {{userPage.firstName}} {{userPage.lastName}}
        </span>
        <span>
          <ng-container *ngIf="companyRole">{{'companyRole.' + companyRole | translate}}<br></ng-container>
          {{userPage.company.name}}
        </span>
        <hr>
        <span *ngIf="userPage.company.seatNumber">
          {{'memberPage.seat' | translate}} {{userPage.company.seatNumber}}
        </span>
      </div>
    </div>
    <div class=" buttons-container d-flex flex-row">
      <a *ngIf="activeUserId !== pageUserId" href="mailto:{{userPage.email}}"
         class="blue-border button-like">
        <img class="contact-icon" src="assets/svg-icons/profile-user/send.svg" alt="">
        {{'memberPage.sendMessage' | translate}}
      </a>


      <button *ngIf="activeUserId === pageUserId" class="blue-border flex-center more-button"
              [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
        {{'memberPage.more' | translate}}
      </button>
      <mat-menu #menu="matMenu" class="profile-user-panel">
        <button class="flex-center mat-menu-button" mat-menu-item *ngIf="activeUserId === pageUserId"
                (click)="showEditField=true">
          <mat-icon>edit icon</mat-icon>
          <span class="text">{{'memberPage.edit' | translate}}</span>
        </button>
      </mat-menu>

    </div>

    <hr class="mx-0 top-separator">

    <div class="content">

      <div class="complete-profile"
           *ngIf="(activeUserId === pageUserId && userPage.offeringLOBs.length == 0 && userPage.lookingForLOBs.length==0 && (userPage.introductionText == null || userPage.introductionText.trim() === '')
           && !userPage.isRepresentative && userPage.type !== Roles.ROLE_EXPERT) || (activeUserId === pageUserId && userPage.type === Roles.ROLE_EXPERT && userPage.offeringExpertServices.length == 0)">
        <img src="assets/svg-icons/circle-actions-alert-info.svg" alt="">
        <span>{{"memberPage.completeInformation"|translate}}</span>
        <button class="blue-border" data-cy="add-button" (click)="showEditField=true" ><img src="assets/svg-icons/actions-plus.svg"
                                                                      alt="">{{"memberPage.addData"|translate}}
        </button>
      </div>
      <div *ngIf="userPage.offeringLOBs.length>0 || userPage.lookingForLOBs.length>0 || userPage.offeringExpertServices.length>0"
           class="specialities-container d-flex flex-row">
        <div class="specialities-container-offering" *ngIf="userPage.offeringLOBs.length>0">
          <span class="headline">
            {{'memberPage.lobsoffering' | translate}}
            <span class="badge">
              {{userPage.offeringLOBs.length}}
            </span>
          </span>
          <div class="chip-list">
            <div class="chip" *ngFor="let lob of userPage.offeringLOBs | slice:0:maxLobShown">
              {{'lineOfBusiness.clauses.' + lob.number + '.name' | translate}}
            </div>
          </div>
          <button *ngIf="userPage.offeringLOBs.length >3"
                  (click)="toggleMaxLobShow()"
                  class="blue-border w-fit-content">{{(maxLobShown == 3 ? 'memberPage.showMore' : 'memberPage.showLess') | translate}}</button>
        </div>
        <div *ngIf="userPage.type === Roles.ROLE_EXPERT" class="specialities-container-offering">
          <span class="headline" *ngIf="userPage.offeringExpertServices.length>0">
            {{'memberPage.expertise' | translate}}
            <span class="badge">
              {{userPage.offeringExpertServices.length}}
            </span>
          </span>
          <div class="chip-list">
            <div class="chip" *ngFor="let serv of userPage.offeringExpertServices | slice:0:maxLobShown">
              {{'expertServices.clauses.' + serv.number + '.name' | translate}}
            </div>
          </div>
          <button *ngIf="userPage.offeringExpertServices.length > 3 "
                  (click)="toggleMaxLobShow()"
                  class="blue-border w-fit-content">{{(maxLobShown == 3 ? 'memberPage.showMore' : 'memberPage.showLess') | translate}}</button>
        </div>
        <div *ngIf="userPage.type !== Roles.ROLE_BROKER" class="specialities-container-interested">
          <span class="headline" *ngIf="userPage.lookingForLOBs.length>0">
            {{'memberPage.lobsinterested' | translate}}
            <span class="badge">
              {{userPage.lookingForLOBs.length}}
            </span>
          </span>
          <div class="chip-list">
            <div class="chip" *ngFor="let lob of userPage.lookingForLOBs | slice:0:maxLobShown">
              {{'lineOfBusiness.clauses.' + lob.number + '.name' | translate}}
            </div>
          </div>
          <button *ngIf="userPage.lookingForLOBs.length > 3 "
                  (click)="toggleMaxLobShow()"
                  class="blue-border w-fit-content">{{(maxLobShown == 3 ? 'memberPage.showMore' : 'memberPage.showLess') | translate}}</button>
        </div>
      </div>

      <div class="information-container d-flex flex-column"
           *ngIf="userPage.introductionText != null && userPage.introductionText.trim() !== ''">
        <span class="title"> {{'memberPage.informationOnMe' | translate}}</span>
        <span #introductionText class="introduction-text"
              [class.show-all]="showCompleteIntroductionText">{{userPage.introductionText}}</span>
        <button class="blue-border w-fit-content"
                *ngIf="showCompleteIntroductionText || (introductionText?.scrollHeight > introductionText?.clientHeight)"
                (click)="toggleCompleteIntroductionText()">{{(showCompleteIntroductionText ? 'memberPage.showLess' : 'memberPage.showMore') | translate}}</button>
      </div>
      <div class="contact-container d-flex flex-column">
        <span class="title"> {{'memberPage.contact' | translate}}</span>
        <div class="d-flex flex-row justify-content-between contact-content">
          <div class="d-flex flex-column contact-information">
            <div class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/mail.svg" alt="">
              <a href="mailto:{{userPage.email}}">
                {{userPage.email}}
              </a>
            </div>
            <div *ngIf="userPage.telephoneNumber" class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/call.svg" alt="">
              <span>
                {{userPage.telephoneNumber}}
               </span>
            </div>
            <div *ngIf="userPage.mobileNumber" class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/device-phone.svg" alt="">
              <span>
                {{userPage.mobileNumber}}
              </span>
            </div>
            <div class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/building-business-office.svg" alt="">
              <a class="company-link" [routerLink]="'/'+ Route.COMPANY_PROFILE+'/'+ userPage.company.companyId">
                {{userPage.company.name}}
              </a>
            </div>
            <div class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/location.svg" alt="">
              <span>
                {{userPage.company.street}} {{userPage.company.houseNumber}},
                {{userPage.company.postalCode}} {{userPage.company.location}}
          </span>
            </div>
          </div>
          <iframe
            *ngIf="userPage.company.street != null && userPage.company.houseNumber != null && userPage.company.postalCode != null && userPage.company.location != null"
            class="flex-grow-1 google-maps"
            title="google-maps"
            style="border:0"
            loading="lazy"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            [src]="('https://www.google.com/maps/embed/v1/place?key='+ environment.mapsApiKey + '&q=' + userPage.company.street + '+' + userPage.company.houseNumber + ',' + userPage.company.postalCode + '+' +userPage.company.location ) | safe">
          </iframe>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="showEditField" class="position-fixed edit-page">

    <ng-scrollbar visibility="hover" class="h-100 ">

      <div class="edit-field d-flex flex-row">
        <app-profile-user-edit (close)="closeEditField()" (updated)="reloadInformation()"
                            class="flex-grow-1 flex-shrink-1 w-50">

        </app-profile-user-edit>
      </div>
    </ng-scrollbar>
  </div>
  <div *ngIf="editImage" class="position-fixed edit-image-container">
    <div class="edit-image">
      <div class="d-flex justify-content-between w-100">
        <span class="title">{{'memberPage.editImage.title'|translate}}</span>
        <mat-icon class="cursor-pointer" (click)="editImage = false">close</mat-icon>
      </div>
      <img alt="profile" class="profile-picture"
           [src]="profilePicture ?? 'assets/img/profile/default-profile-icon.png'"/>
      <div class="buttons">
        <label for="profile-logo-upload">
          <img src="assets/svg-icons/camera.svg" alt="">
          <label for="profile-logo-upload">{{'memberPage.editImage.add'|translate}}</label>

        </label>
        <input id="profile-logo-upload" type="file" accept="image/png, image/jpeg"
               (change)="onFileChange($event, 'profilePicture')"
               class="d-none">
        <div (click)="deleteProfilePicture()">
          <img src="assets/svg-icons/delete.svg" alt="">
          <span>{{'memberPage.editImage.delete'|translate}}</span>
        </div>
      </div>
    </div>
  </div>
</ng-scrollbar>
